// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"966eabc9","455":"ab1d43cf","977":"dc08da06"}[chunkId] + ".chunk.js";
};